const loader = () => '<div class="lds-ring"><div></div><div></div><div></div><div></div></div>';

export default loader;
